import { createRouter, createWebHistory } from "vue-router";
import { ReviseMeta } from "@/util/meta";
import { deviceType } from "@/util/base";

// 定义广告平台及版本映射
const adRoutesVersions = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "B2",
  "C2",
  "D2",
];

// 特殊映射
const adRoutesComponentMap = { L: "A", M: "F" };

// 定义平台
const platforms = [
  {
    prefix: "TT",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // 抖音
  {
    prefix: "FB",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // 脸书
  {
    prefix: "GG",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // 谷歌
  {
    prefix: "tw",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // 推特
  {
    prefix: "TW",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // 推特
  {
    prefix: "Zucksad",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // Zucksad渠道
  {
    prefix: "Zucks",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // Zucks渠道
  {
    prefix: "AMoAd",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // AMoAd渠道
  {
    prefix: "SeedApp",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // SeedApp渠道
  {
    prefix: "imobile",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // imobile渠道
  {
    prefix: "SKYFLAG",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // SKYFLAG渠道
  {
    prefix: "Smartnews",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // Smartnews渠道
  {
    prefix: "line",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // line渠道
  {
    prefix: "unicorn",
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  }, // unicorn渠道
];

// 使用 import.meta.glob 导入所有组件
const downComponents = import.meta.glob("./views/down/*.vue");
const shopComponents = import.meta.glob("./views/shop/*.vue");

function createAdRoutes(platforms, prefix, components) {
  return platforms.flatMap(
    ({ prefix: platformPrefix, versions, componentMap }) =>
      versions.map((version) => {
        // 确定组件路径
        const componentName = componentMap[version] || version;
        const componentPath = `./views/${prefix}/${componentName}.vue`;

        return {
          path: `${platformPrefix}-${version}`, // 子路由路径
          name: `${prefix}-${platformPrefix}-${version}`,
          component: components[componentPath], // 使用 import.meta.glob 动态导入组件
        };
      })
  );
}

const downRoutes = createAdRoutes(platforms, "down", downComponents);
const shopRoutes = createAdRoutes(platforms, "shop", shopComponents);

console.log("Down Routes:", downRoutes);
console.log("Shop Routes:", shopRoutes);

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // 入口页面
    {
      path: "/",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title:
          "『メイプルストーリーR：エボリューション』ネクソン監修の最新作！好評配信中！",
        description:
          "ネクソン監修のRPG『メイプルストーリーR: エボリューション』へようこそ！指一本でラクラク進化する「メイプルストーリー」の世界をスマホで体験しよう！『メイプルストーリーR: エボリューション』の公式サイト。",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    {
      path: "/m",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title:
          "『メイプルストーリーR：エボリューション』ネクソン監修の最新作！好評配信中！",
        description:
          "ネクソン監修のRPG『メイプルストーリーR: エボリューション』へようこそ！指一本でラクラク進化する「メイプルストーリー」の世界をスマホで体験しよう！『メイプルストーリーR: エボリューション』の公式サイト。",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    {
      path: "/pre",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "『メイプルストーリーR：エボリューション』ネクソン監修の最新作！好評配信中！",
        description:
          "ネクソン監修のRPG『メイプルストーリーR: エボリューション』へようこそ！指一本でラクラク進化する「メイプルストーリー」の世界をスマホで体験しよう！『メイプルストーリーR: エボリューション』の公式サイト。",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    {
      path: "/pre/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "『メイプルストーリーR：エボリューション』ネクソン監修の最新作！好評配信中！",
        description:
          "ネクソン監修のRPG『メイプルストーリーR: エボリューション』へようこそ！指一本でラクラク進化する「メイプルストーリー」の世界をスマホで体験しよう！『メイプルストーリーR: エボリューション』の公式サイト。",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    // 预约审核页
    {
      path: "/audit",
      component: () => import("./views/audit/index.vue"),
      meta: {
        title:
          "『メイプルストーリーR：エボリューション』ネクソン監修の最新作！好評配信中！",
        description:
          "ネクソン監修のRPG『メイプルストーリーR: エボリューション』へようこそ！指一本でラクラク進化する「メイプルストーリー」の世界をスマホで体験しよう！『メイプルストーリーR: エボリューション』の公式サイト。",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    {
      path: "/audit/m",
      component: () => import("./views/audit/index.vue"),
      meta: {
        title:
          "『メイプルストーリーR：エボリューション』ネクソン監修の最新作！好評配信中！",
        description:
          "ネクソン監修のRPG『メイプルストーリーR: エボリューション』へようこそ！指一本でラクラク進化する「メイプルストーリー」の世界をスマホで体験しよう！『メイプルストーリーR: エボリューション』の公式サイト。",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    // 单手杀
    {
      path: "/game",
      component: () => import("./views/game/index.vue"),
      meta: {
        title:
          "メイプルストーリーR：エボリューション｜「指一本チャレンジ」特設サイト",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    {
      path: "/game/m",
      component: () => import("./views/game/index.vue"),
      meta: {
        title:
          "メイプルストーリーR：エボリューション｜「指一本チャレンジ」特設サイト",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    // dmm预注册
    {
      path: "/dmg/pre",
      component: () => import("./views/dmm/pre.vue"),
      meta: {
        title: "メイプルストーリーR：エボリューション ❘ DMM版事前登録受付中",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』DMM版事前登録受付中！",
        keywords:
          "DMM GAMES,DMM,公式サイト,メイプルストーリーR: エボリューション,メイプルストーリーR,エボリューション,メイプルストーリーＭ,メイプルＭ,メイプルストーリー,メイプル,iPhone,Android,ネクソン,NEXON,キノコ,公式ライセンス,好評配信中,事前登録,放置ゲーム,カジュアルゲーム,カードゲーム,ネタゲーム,RPG,カードRPG,放置系,無料ゲーム,ゆるかわ,ミニゲーム,role playing,リセマラ不要,まったり,課金なし,おもちゃ,放置冒険RPG,放置カードRPG,オンラインゲーム,スマホゲーム,ゲーム,無料オンラインゲーム,楽しめる,楽々,ラクラク,進化,指一本,特典もりもり,縦画面,オート,どこでも,いつでも,誰でも遊べる,簡単操作,PS5,Switch,iPhone16,アマギフ,海外旅行,航空券,特典満載,豪華賞品,ドット勇者,ダークテイルズ,ダーク姫,メメントモリ,放置少女,妖遊記,サンローラン騎士団,ガイコツさん,三魚国志,剣と勇者とレベル上げ,ラグナドール,こんにちワン！ヒーロー,フォートレスサガ,AFK アリーナ,キノコ勇者,キノコ伝説,キノデン,キノデンH5,キノコ伝説H5,勇者,SSR,ダンジョン,共闘,カード,ギルド,ジョブ,ガチャ,特典,無料,育成,戦力,社交,アニメ,逆襲,自動戦闘,オートモード,レベルアップ,ペット,仲間,職業,転職,キャラ",
      },
    },
    {
      path: "/dmg/pre/m",
      component: () => import("./views/dmm/pre.vue"),
      meta: {
        title: "メイプルストーリーR：エボリューション ❘ DMM版事前登録受付中",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』DMM版事前登録受付中！",
        keywords:
          "DMM GAMES,DMM,公式サイト,メイプルストーリーR: エボリューション,メイプルストーリーR,エボリューション,メイプルストーリーＭ,メイプルＭ,メイプルストーリー,メイプル,iPhone,Android,ネクソン,NEXON,キノコ,公式ライセンス,好評配信中,事前登録,放置ゲーム,カジュアルゲーム,カードゲーム,ネタゲーム,RPG,カードRPG,放置系,無料ゲーム,ゆるかわ,ミニゲーム,role playing,リセマラ不要,まったり,課金なし,おもちゃ,放置冒険RPG,放置カードRPG,オンラインゲーム,スマホゲーム,ゲーム,無料オンラインゲーム,楽しめる,楽々,ラクラク,進化,指一本,特典もりもり,縦画面,オート,どこでも,いつでも,誰でも遊べる,簡単操作,PS5,Switch,iPhone16,アマギフ,海外旅行,航空券,特典満載,豪華賞品,ドット勇者,ダークテイルズ,ダーク姫,メメントモリ,放置少女,妖遊記,サンローラン騎士団,ガイコツさん,三魚国志,剣と勇者とレベル上げ,ラグナドール,こんにちワン！ヒーロー,フォートレスサガ,AFK アリーナ,キノコ勇者,キノコ伝説,キノデン,キノデンH5,キノコ伝説H5,勇者,SSR,ダンジョン,共闘,カード,ギルド,ジョブ,ガチャ,特典,無料,育成,戦力,社交,アニメ,逆襲,自動戦闘,オートモード,レベルアップ,ペット,仲間,職業,転職,キャラ",
      },
    },
    // dmm登录
    {
      path: "/dmg",
      component: () => import("./views/dmm/index.vue"),
      meta: {
        title: "メイプルストーリーR：エボリューション ❘ DMM版公式サイト",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』はDMM GAMESにて好評配信中！",
        keywords:
          "DMM GAMES,DMM,公式サイト,メイプルストーリーR: エボリューション,メイプルストーリーR,エボリューション,メイプルストーリーＭ,メイプルＭ,メイプルストーリー,メイプル,iPhone,Android,ネクソン,NEXON,キノコ,公式ライセンス,好評配信中,事前登録,放置ゲーム,カジュアルゲーム,カードゲーム,ネタゲーム,RPG,カードRPG,放置系,無料ゲーム,ゆるかわ,ミニゲーム,role playing,リセマラ不要,まったり,課金なし,おもちゃ,放置冒険RPG,放置カードRPG,オンラインゲーム,スマホゲーム,ゲーム,無料オンラインゲーム,楽しめる,楽々,ラクラク,進化,指一本,特典もりもり,縦画面,オート,どこでも,いつでも,誰でも遊べる,簡単操作,PS5,Switch,iPhone16,アマギフ,海外旅行,航空券,特典満載,豪華賞品,ドット勇者,ダークテイルズ,ダーク姫,メメントモリ,放置少女,妖遊記,サンローラン騎士団,ガイコツさん,三魚国志,剣と勇者とレベル上げ,ラグナドール,こんにちワン！ヒーロー,フォートレスサガ,AFK アリーナ,キノコ勇者,キノコ伝説,キノデン,キノデンH5,キノコ伝説H5,勇者,SSR,ダンジョン,共闘,カード,ギルド,ジョブ,ガチャ,特典,無料,育成,戦力,社交,アニメ,逆襲,自動戦闘,オートモード,レベルアップ,ペット,仲間,職業,転職,キャラ",
      },
    },
    {
      path: "/dmg/m",
      component: () => import("./views/dmm/index.vue"),
      meta: {
        title: "メイプルストーリーR：エボリューション ❘ DMM版公式サイト",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』はDMM GAMESにて好評配信中！",
        keywords:
          "DMM GAMES,DMM,公式サイト,メイプルストーリーR: エボリューション,メイプルストーリーR,エボリューション,メイプルストーリーＭ,メイプルＭ,メイプルストーリー,メイプル,iPhone,Android,ネクソン,NEXON,キノコ,公式ライセンス,好評配信中,事前登録,放置ゲーム,カジュアルゲーム,カードゲーム,ネタゲーム,RPG,カードRPG,放置系,無料ゲーム,ゆるかわ,ミニゲーム,role playing,リセマラ不要,まったり,課金なし,おもちゃ,放置冒険RPG,放置カードRPG,オンラインゲーム,スマホゲーム,ゲーム,無料オンラインゲーム,楽しめる,楽々,ラクラク,進化,指一本,特典もりもり,縦画面,オート,どこでも,いつでも,誰でも遊べる,簡単操作,PS5,Switch,iPhone16,アマギフ,海外旅行,航空券,特典満載,豪華賞品,ドット勇者,ダークテイルズ,ダーク姫,メメントモリ,放置少女,妖遊記,サンローラン騎士団,ガイコツさん,三魚国志,剣と勇者とレベル上げ,ラグナドール,こんにちワン！ヒーロー,フォートレスサガ,AFK アリーナ,キノコ勇者,キノコ伝説,キノデン,キノデンH5,キノコ伝説H5,勇者,SSR,ダンジョン,共闘,カード,ギルド,ジョブ,ガチャ,特典,無料,育成,戦力,社交,アニメ,逆襲,自動戦闘,オートモード,レベルアップ,ペット,仲間,職業,転職,キャラ",
      },
    },
    // dmm内容
    {
      path: "/article",
      component: () => import("./views/dmm/content.vue"),
      meta: {
        title: "メイプルストーリーR：エボリューション ❘ DMM版公式サイト",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』はDMM GAMESにて好評配信中！",
        keywords:
          "DMM GAMES,DMM,公式サイト,メイプルストーリーR: エボリューション,メイプルストーリーR,エボリューション,メイプルストーリーＭ,メイプルＭ,メイプルストーリー,メイプル,iPhone,Android,ネクソン,NEXON,キノコ,公式ライセンス,好評配信中,事前登録,放置ゲーム,カジュアルゲーム,カードゲーム,ネタゲーム,RPG,カードRPG,放置系,無料ゲーム,ゆるかわ,ミニゲーム,role playing,リセマラ不要,まったり,課金なし,おもちゃ,放置冒険RPG,放置カードRPG,オンラインゲーム,スマホゲーム,ゲーム,無料オンラインゲーム,楽しめる,楽々,ラクラク,進化,指一本,特典もりもり,縦画面,オート,どこでも,いつでも,誰でも遊べる,簡単操作,PS5,Switch,iPhone16,アマギフ,海外旅行,航空券,特典満載,豪華賞品,ドット勇者,ダークテイルズ,ダーク姫,メメントモリ,放置少女,妖遊記,サンローラン騎士団,ガイコツさん,三魚国志,剣と勇者とレベル上げ,ラグナドール,こんにちワン！ヒーロー,フォートレスサガ,AFK アリーナ,キノコ勇者,キノコ伝説,キノデン,キノデンH5,キノコ伝説H5,勇者,SSR,ダンジョン,共闘,カード,ギルド,ジョブ,ガチャ,特典,無料,育成,戦力,社交,アニメ,逆襲,自動戦闘,オートモード,レベルアップ,ペット,仲間,職業,転職,キャラ",
      },
    },
    {
      path: "/article/m",
      component: () => import("./views/dmm/content.vue"),
      meta: {
        title: "メイプルストーリーR：エボリューション ❘ DMM版公式サイト",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』はDMM GAMESにて好評配信中！",
        keywords:
          "DMM GAMES,DMM,公式サイト,メイプルストーリーR: エボリューション,メイプルストーリーR,エボリューション,メイプルストーリーＭ,メイプルＭ,メイプルストーリー,メイプル,iPhone,Android,ネクソン,NEXON,キノコ,公式ライセンス,好評配信中,事前登録,放置ゲーム,カジュアルゲーム,カードゲーム,ネタゲーム,RPG,カードRPG,放置系,無料ゲーム,ゆるかわ,ミニゲーム,role playing,リセマラ不要,まったり,課金なし,おもちゃ,放置冒険RPG,放置カードRPG,オンラインゲーム,スマホゲーム,ゲーム,無料オンラインゲーム,楽しめる,楽々,ラクラク,進化,指一本,特典もりもり,縦画面,オート,どこでも,いつでも,誰でも遊べる,簡単操作,PS5,Switch,iPhone16,アマギフ,海外旅行,航空券,特典満載,豪華賞品,ドット勇者,ダークテイルズ,ダーク姫,メメントモリ,放置少女,妖遊記,サンローラン騎士団,ガイコツさん,三魚国志,剣と勇者とレベル上げ,ラグナドール,こんにちワン！ヒーロー,フォートレスサガ,AFK アリーナ,キノコ勇者,キノコ伝説,キノデン,キノデンH5,キノコ伝説H5,勇者,SSR,ダンジョン,共闘,カード,ギルド,ジョブ,ガチャ,特典,無料,育成,戦力,社交,アニメ,逆襲,自動戦闘,オートモード,レベルアップ,ペット,仲間,職業,転職,キャラ",
      },
    },
    // 广告投放营销预约页FB-X渠道
    {
      path: "/pre/FB",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "ネクソン監修の最新作！事前登録受付中",
        description:
          "ネクソン監修のスマホRPG は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    {
      path: "/pre/FB/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title: "ネクソン監修の最新作！事前登録受付中",
        description:
          "ネクソン監修のスマホRPG は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    // 广告投放营销预约页GG-Y渠道
    {
      path: "/pre/GG",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "メイプルストーリーR：エボリューション｜ネクソン監修の最新作！事前登録受付中",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    {
      path: "/pre/GG/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "メイプルストーリーR：エボリューション｜ネクソン監修の最新作！事前登録受付中",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    // 广告投放营销预约页GG1渠道
    {
      path: "/pre/GG1",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "メイプルストーリーR：エボリューション｜ネクソン監修の最新作！事前登録受付中",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    {
      path: "/pre/GG1/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "メイプルストーリーR：エボリューション｜ネクソン監修の最新作！事前登録受付中",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    // 广告投放营销预约页GG2渠道
    {
      path: "/pre/GG2",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "メイプルストーリーR：エボリューション｜ネクソン監修の最新作！事前登録受付中",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    {
      path: "/pre/GG2/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "メイプルストーリーR：エボリューション｜ネクソン監修の最新作！事前登録受付中",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    // 广告投放营销预约页TT-Z渠道
    {
      path: "/pre/TT",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "メイプルストーリーR：エボリューション｜ネクソン監修の最新作！事前登録受付中",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    {
      path: "/pre/TT/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "メイプルストーリーR：エボリューション｜ネクソン監修の最新作！事前登録受付中",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    // 广告投放营销预约页TW渠道
    {
      path: "/pre/TW",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "メイプルストーリーR：エボリューション｜ネクソン監修の最新作！事前登録受付中",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    {
      path: "/pre/TW/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "メイプルストーリーR：エボリューション｜ネクソン監修の最新作！事前登録受付中",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    // 广告投放营销预约页line渠道
    {
      path: "/pre/line",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "メイプルストーリーR：エボリューション｜ネクソン監修の最新作！事前登録受付中",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    {
      path: "/pre/line/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "メイプルストーリーR：エボリューション｜ネクソン監修の最新作！事前登録受付中",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    // 广告投放营销预约页CM渠道
    {
      path: "/pre/CM",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "メイプルストーリーR：エボリューション｜ネクソン監修の最新作！事前登録受付中",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    {
      path: "/pre/CM/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "メイプルストーリーR：エボリューション｜ネクソン監修の最新作！事前登録受付中",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    // 寻宝页
    {
      path: "/treasure",
      component: () => import("./views/treasure/index.vue"),
      meta: {
        title:
          "メイプルストーリーR：エボリューション｜ネクソン監修の最新作！事前登録受付中",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    {
      path: "/treasure/m",
      component: () => import("./views/treasure/index.vue"),
      meta: {
        title:
          "メイプルストーリーR：エボリューション｜ネクソン監修の最新作！事前登録受付中",
        description:
          "ネクソン監修のスマホRPG『メイプルストーリーR：エボリューション』は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    // 官网首页
    {
      path: "/home",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title: "《三國屍心瘋》官方網站-萬屍俱備，只欠發瘋！",
        description:
          "超ㄎㄧㄤ無厘頭殭屍三國放置手遊-《三國屍心瘋》下載即送3000抽和港澳台限定時裝-紅衣小女孩！三國武將全員屍化搞怪來襲！化身道士招募殭屍武將，躺平FUN屍爽！",
        keywords:
          "三國屍心瘋,失心瘋,三國,殭屍,名將,英魂,喪屍,殭王,魔神,重生,末世,歷史,道士,招魂, 盜墓, 醜萌, 搞怪, 策略, 搭配, 佈陣, 卡牌, 抽卡, 佛系, 摸魚, 休閒, 收菜, 放置, 掛機, 無需操作, 豎版, kuso, ㄎㄧㄤ, 無厘頭,  惡搞, 戰鬥，卡牌，多英雄，聯盟,  軍團，開箱，福利，免費遊戲，養成，戰力，社交，動漫，逆襲，進化，放置掛機，升級, 爽快割草, 無限開寶箱，無限開神燈，輕鬆休閒，不肝不課，無門檻福利遊戲,玩具，神器, PS5, Switch, Airpods, iPad Air, iPhone 16 pro, mycard, 免費送, 下載就送, 下載好禮, 下載豪禮, 3000抽,三國屍心瘋官網, 官網 , 免費玩,放置遊戲, 超休閒遊戲, 卡牌養成遊戲，搞怪遊戲，RPG，卡牌RPG手遊，放置卡牌RPG，放置冒險RPG, 殭屍RPG，角色扮演, 不休小隊, 小妖問道，Monster Hunter Now，庫洛魔法使：回憶鑰匙合合合英雄，射射英雄，菇勇者傳說，三國志幻想大陸，眾神派對，馬賽克英雄，噠噠特工，道士出觀，劍與遠征，噠噠騎士團，魔鏡物語，楓之谷, 英雄你好狗, 出發吧麥芬, 轟天騎士團, 潘朵拉, 甘道夫醒醒啦, 土豆兄弟, 暴走小蝦米, 吸血鬼幸存者, 神魔三國志，鹹魚之王，一念逍遙，香腸三國，少年猛將傳，放置七騎士，熱血大作戰、少年神獸傳、太鼓三國志、最後的道長、鬼武三國",
      },
    },
    {
      path: "/home/m",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title: "《三國屍心瘋》官方網站-萬屍俱備，只欠發瘋！",
        description:
          "超ㄎㄧㄤ無厘頭殭屍三國放置手遊-《三國屍心瘋》下載即送3000抽和港澳台限定時裝-紅衣小女孩！三國武將全員屍化搞怪來襲！化身道士招募殭屍武將，躺平FUN屍爽！",
        keywords:
          "三國屍心瘋,失心瘋,三國,殭屍,名將,英魂,喪屍,殭王,魔神,重生,末世,歷史,道士,招魂, 盜墓, 醜萌, 搞怪, 策略, 搭配, 佈陣, 卡牌, 抽卡, 佛系, 摸魚, 休閒, 收菜, 放置, 掛機, 無需操作, 豎版, kuso, ㄎㄧㄤ, 無厘頭,  惡搞, 戰鬥，卡牌，多英雄，聯盟,  軍團，開箱，福利，免費遊戲，養成，戰力，社交，動漫，逆襲，進化，放置掛機，升級, 爽快割草, 無限開寶箱，無限開神燈，輕鬆休閒，不肝不課，無門檻福利遊戲,玩具，神器, PS5, Switch, Airpods, iPad Air, iPhone 16 pro, mycard, 免費送, 下載就送, 下載好禮, 下載豪禮, 3000抽,三國屍心瘋官網, 官網 , 免費玩,放置遊戲, 超休閒遊戲, 卡牌養成遊戲，搞怪遊戲，RPG，卡牌RPG手遊，放置卡牌RPG，放置冒險RPG, 殭屍RPG，角色扮演, 不休小隊, 小妖問道，Monster Hunter Now，庫洛魔法使：回憶鑰匙合合合英雄，射射英雄，菇勇者傳說，三國志幻想大陸，眾神派對，馬賽克英雄，噠噠特工，道士出觀，劍與遠征，噠噠騎士團，魔鏡物語，楓之谷, 英雄你好狗, 出發吧麥芬, 轟天騎士團, 潘朵拉, 甘道夫醒醒啦, 土豆兄弟, 暴走小蝦米, 吸血鬼幸存者, 神魔三國志，鹹魚之王，一念逍遙，香腸三國，少年猛將傳，放置七騎士，熱血大作戰、少年神獸傳、太鼓三國志、最後的道長、鬼武三國",
      },
    },
    // 下载
    {
      path: "/down",
      meta: {
        title: "ネクソン監修の最新作！事前登録受付中",
        description:
          "ネクソン監修のスマホRPG は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
      children: downRoutes,
    },
    // 商店
    {
      path: "/shop",
      meta: {
        title: "ネクソン監修の最新作！事前登録受付中",
        description:
          "ネクソン監修のスマホRPG は今事前登録受付中！予約で限定コーデ、SSRペットなどの豪華特典をゲット！",
        keywords:
          "オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
      children: shopRoutes,
    },
    // 名片分享活动
    {
      path: "/resume",
      component: () => import("./views/resume/index.vue"),
      meta: {
        title:
          "『メイプルストーリーR：エボリューション』自己紹介カード作成ツール",
        description:
          "ネクソン監修のRPG『メイプルストーリーR: エボリューション』へようこそ！指一本でラクラク進化する「メイプルストーリー」の世界をスマホで体験しよう！『メイプルストーリーR: エボリューション』の公式サイト。",
        keywords:
          "メイプルストーリーＭ,メイプルＭ,オンラインゲーム,スマホゲーム,ゲーム,無料ゲーム,無料オンラインゲーム,iPhone,Android,ネクソン,NEXON",
      },
    },
    // 404
    {
      path: "/:pathMatch(.*)*",
      component: () => import("../../components/404.vue"),
    },
    // 测试
    {
      path: "/test",
      component: () => import("./views/test.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  ReviseMeta(to.meta.title, to.meta.keywords, to.meta.description);

  const specialPages = [
    /^\/down(\/.*)?$/,
    /^\/shop(\/.*)?$/,
    /^\/resume(\/.*)?$/,
  ];
  const isSpecialPage = specialPages.some((pattern) => pattern.test(to.path));

  if (isSpecialPage) {
    next();
    return;
  }

  const isWap = deviceType() == "wap";
  const pcPath = to.path.replace(/\/m$/, "");
  const wapPath = pcPath.endsWith("/") ? `${pcPath}m` : `${pcPath}/m`;

  if (isWap && !to.path.endsWith("/m")) {
    next({ path: wapPath, query: to.query });
  } else if (!isWap && to.path.endsWith("/m")) {
    next({ path: pcPath, query: to.query });
  } else {
    next();
  }
});

export default router;
